<app-modal #modal slug="size-guide">
  <div class="size-guide">
    <img [src]="src" (click)="modal.closeModal()" />
  </div>
</app-modal>
